import { render } from "./RoomLink.vue?vue&type=template&id=cdf89d00&scoped=true"
import script from "./RoomLink.vue?vue&type=script&lang=js"
export * from "./RoomLink.vue?vue&type=script&lang=js"

import "./RoomLink.vue?vue&type=style&index=0&id=cdf89d00&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cdf89d00"

export default script